import { NextPage } from 'next';

import { PricingPage, PricingPageProps } from '../components/Pages';

const PricingNextPage: NextPage<PricingPageProps> = () => {
  return <PricingPage />;
};

// eslint-disable-next-line import/no-default-export
export default PricingNextPage;
